import React from "react";
import {
  dataUrl,
  getJobLocationById,
  getWorkExpText,
  toArray,
} from "../../../../helpers/common";
import {
  getEndData,
  getStartData,
} from "../../../Account/Candidate/MyProfile/ExperienceJourney";
import WebsiteLogo from "../../../../helpers/WebsiteLogo";
import styles from "./ResumeTemplateModern.module.css";
import { getCertificationValidity } from "..";

const Sidebar = ({ formData, jobLocations }) => (
  <div className={styles.sidebar}>
    <img
      src={`${dataUrl}/customers/${formData?.profile_picture}`}
      alt={""}
      className={styles.profilePic}
    />
    {formData?.name && <h1 className={styles.name}>{formData?.name}</h1>}
    {formData?.designation && (
      <p className={styles.designation}>{formData?.designation}</p>
    )}

    <div className={styles.contactInfo}>
      <h2 className={styles.sectionTitle}>Contacts</h2>

      {formData.mobile_number && (
        <p className={styles.contactItem}>
          <strong>Phone</strong>
          <span> {formData.mobile_number}</span>
        </p>
      )}
      {formData.email && (
        <p className={styles.contactItem}>
          <strong>Email</strong>
          <span>
            <a href={`mailto:${formData.email}`}>{formData.email}</a>
          </span>
        </p>
      )}
      {formData?.location && (
        <p className={styles.contactItem}>
          <strong>Location</strong>
          <span>
            {getJobLocationById(formData?.location, jobLocations)}, India
          </span>
        </p>
      )}
    </div>
    {formData?.skills && (
      <div className={styles.skills}>
        <h2 className={styles.sectionTitle}>Skills</h2>
        <ul>
          {toArray(formData?.skills)
            ?.slice(0, 15)
            ?.map((skill, index) => (
              <li key={index}>
                <strong>-</strong> {skill}
              </li>
            ))}
        </ul>
      </div>
    )}

    {formData?.hobbies && (
      <div className={styles.skills}>
        <h2 className={styles.sectionTitle}>Hobbies</h2>
        <ul>
          {toArray(formData?.hobbies)
            ?.slice(0, 15)
            ?.map((item, index) => (
              <li key={index}>
                <strong>-</strong> {item}
              </li>
            ))}
        </ul>
      </div>
    )}

    {formData?.languages_known && (
      <div className={styles.skills}>
        <h2 className={styles.sectionTitle}>Languages</h2>
        <ul>
          {toArray(formData?.languages_known)
            ?.slice(0, 15)
            ?.map((item, index) => (
              <li key={index}>
                <strong>-</strong> {item}
              </li>
            ))}
        </ul>
      </div>
    )}
  </div>
);

const Experience = ({ experience, resumeBuilder }) => {
  const totalExperience = resumeBuilder?.total_work_experience
    ? `(${getWorkExpText(resumeBuilder?.total_work_experience)?.trim()})`
    : "";

  if (!experience?.length) {
    return null;
  }
  return (
    <section>
      <h2 className={styles.sectionTitle}>Work Experience {totalExperience}</h2>
      {experience?.map((job, index) => (
        <div className={styles.job} key={index}>
          <p className={styles.jobTitle}>{job?.additional_fields?.position}</p>
          <p className={styles.jobDate}>
            {job?.additional_fields?.company_name} - (
            {getStartData(job?.additional_fields) +
              " - " +
              getEndData(job?.additional_fields)}
            )
          </p>

          <p>{job?.additional_fields?.details}</p>
        </div>
      ))}
    </section>
  );
};

const Education = ({ educations }) => {
  if (!educations?.length) {
    return null;
  }
  return (
    <section>
      <h2 className={styles.sectionTitle}>Education</h2>

      {educations?.map((education, idx) => (
        <div key={idx}>
          <p className="mb-0">
            <strong>{education?.additional_fields?.title}</strong>
          </p>
          <p className={styles.jobDate}>
            {education?.additional_fields?.university_college} - (
            {getStartData(education?.additional_fields) +
              " - " +
              getEndData(education?.additional_fields)}
            )
          </p>
          {education?.additional_fields?.certification && (
            <p style={{ color: "#0008" }}>
              <strong>Certification</strong>:{" "}
              {education?.additional_fields?.certification}
            </p>
          )}
        </div>
      ))}
    </section>
  );
};

const Certification = ({ certifications }) => {


  if (!certifications?.length) {
    return null;
  }
  return (
    <section>
      <h2 className={styles.sectionTitle}>Certification</h2>

      {certifications?.map((education, idx) => (
        <div key={idx}>
          <p className="mb-0">
            <strong>{education?.additional_fields?.title}</strong>
            {education?.additional_fields?.url && (
              <a
                href={education?.additional_fields?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2"
              >
                <i className="uil uil-external-link-alt"></i>
              </a>
            )}
          </p>
          {education?.additional_fields?.organization && (
            <span className={`${styles.jobDate} me-2`}>
              <strong>{education?.additional_fields?.organization}</strong>
            </span>
          )}

          <p className={styles.jobDate}>{getCertificationValidity(education)}</p>
        </div>
      ))}
    </section>
  );
};

const ResumeTemplateModern = ({
  formData,
  jobLocations,
  experiences,
  certifications,
  qualifications,
}) => {
  return (
    <div className={styles.resumeContainer}>
      <Sidebar formData={formData} jobLocations={jobLocations} />
      <div className={styles.mainContent}>
        {formData?.details && (
          <section>
            <h2 className={styles.sectionTitle}>Summary</h2>
            <p>{formData?.details}</p>
          </section>
        )}
        <Experience experience={experiences} resumeBuilder={formData} />
        <Education educations={qualifications} />
        <Certification certifications={certifications} />

        {/* Resume Footer */}
        <div className="resume-footer">
          Generated by{" "}
          <a href="https://jobseekerspage.com/">
            <WebsiteLogo />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResumeTemplateModern;
